import { render, staticRenderFns } from "./resizer.vue?vue&type=template&id=d3799768&scoped=true&"
import script from "./resizer.vue?vue&type=script&lang=js&"
export * from "./resizer.vue?vue&type=script&lang=js&"
import style0 from "./resizer.vue?vue&type=style&index=0&id=d3799768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3799768",
  null
  
)

export default component.exports